import { Component, inject } from '@angular/core';
import { LoginService } from '../../../Model/Login/login.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { NgbActiveModal, NgbCarouselModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { RouterOutlet } from '@angular/router';
import { NgOtpInputModule } from 'ng-otp-input';

@Component({
  selector: 'app-company-selection',
  standalone: true,
  imports: [RouterOutlet, FormsModule, CommonModule, HttpClientModule, NgbNavModule, NgOtpInputModule, NgbCarouselModule],
  templateUrl: './company-selection.component.html',
  styleUrl: './company-selection.component.scss'
})
export class CompanySelectionComponent {
  isDisabled: boolean = false;
  active = 1;
  TabIndex = 1;
  Companys: any[] = [];
  user = [] as any;
  activeModal = inject(NgbActiveModal);

  constructor(
    private login: LoginService,
    private toast: ToastService,
    private session: SessionService,
  ) {
    this.user = this.session.GetUserDetails();
  }

  ngOnInit(): void {
    this.GetCompany();
  }

  GetCompany() {
    this.isDisabled = true;
    this.login.GetCompany(this.user, this.user.ApiUrl).subscribe({
      next: (response) => {
        this.Companys = response.CompanySelection;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  CompanyValidate(form: any) {
    if (form.valid) {
      this.Save();
    }
    else {
      form.submitted = true;
    }
  }

  async Save() {
    this.isDisabled = true;
    if (this.user.UserType == 'A') {
      if (this.Companys[this.Companys.findIndex(e => e.CompanyMasterId == this.user.CompanyMasterId)].CompanyLogoPath != null && this.Companys[this.Companys.findIndex(e => e.CompanyMasterId == this.user.CompanyMasterId)].CompanyLogoPath != "") {
        this.user.CompanyLogo = this.Companys[this.Companys.findIndex(e => e.CompanyMasterId == this.user.CompanyMasterId)].CompanyLogoPath;
      }
      this.user.CompanyCode = this.Companys[this.Companys.findIndex(e => e.CompanyMasterId == this.user.CompanyMasterId)].CompanyCode;
      this.user.CompanyName = this.Companys[this.Companys.findIndex(e => e.CompanyMasterId == this.user.CompanyMasterId)].CompanyName;
    }
    if (await this.session.Start(this.user)) {
      this.DbNameWithSessionInsret();
    }
    this.isDisabled = false;
  }

  DbNameWithSessionInsret() {
    this.isDisabled = true;
    this.login.DbNameWithSessionInsret({ OpType: 'U', SessionId: this.user.SessionID, DbName: this.Companys[this.Companys.findIndex(e => e.CompanyMasterId == this.user.CompanyMasterId)].DBName }, this.user.ApiUrl).subscribe({
      next: (response) => {
        if (response.Error_Code == '01') {
          this.close(true);
        } else {
          this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  close(result:boolean) {
    this.activeModal.close(result);
  }
}
